import { LoyaltySvgIcon, type LoyaltyIconProps } from './LoyaltySvgIcon';

export const IceCreamIcon = (props: LoyaltyIconProps): JSX.Element => (
    <LoyaltySvgIcon {...props}>
        {/* Scoop — slightly wider than the cone for a readable overhang */}
        <circle cx="12" cy="7.6" r="5.2" />
        {/* Cone — separated from the scoop by a small gap so it never blurs into a blob */}
        <path d="M7.4 14.1h9.2L12 22.2z" />
    </LoyaltySvgIcon>
);
